import React from 'react';
function OneField (props) {
    return (
        <div className='px-[1%] w-[100%] flex py-2.5'>
            <div className='w-[100%] flex justify-between'>
                <div className='w-[9%] self-center font-"roboto" font-[400] text-[14px] leading-[15px] text-[#757575]'>
                    {props.field1} :
                </div>
                <div className='w-[88.5%]'>
                    <input
                        className='h-[38px] w-full text-[15px] text-[#8F8F8F] pl-[10px] self-center border-[1px] border-[#E3E3E3] text-input required bg-[#F3F3F3] outline-none'
                        type='text'
                        value={props.value}
                        name={props.name}
                        id={props.id}
                        onChange={props.onChange}
                        onBlur={props.onBlur}
                        placeholder={props.placeholder}
                    />
                </div>
            </div>
        </div>
    );
}

export default OneField;
